module.exports = __webpack_public_path__ + "static/media/chevron_left_gray.fd202d4a.svg";